import { Dispatch } from 'redux';
import { connect } from 'react-redux';
import { formValueSelector } from 'redux-form';
import { DispatchProps, OwnProps, StateProps } from './OrderCreateScreen';
import OrderCreate from './OrderCreateScreen';
import { StoreState } from 'src/store/reducers';
import { QueryParams } from 'src/types/grid';
import { getStudents } from 'src/store/actions/student-actions';
import OrderEnum from 'src/enumerables/order-enum';
import { getValFromEnum } from 'src/components/redux-form/utils/dropdown-values';
import { getServiceTypes } from 'src/store/actions/service-type-actions';
import { selectNameStudents } from '../../../../../../store/selectors/students-selectors';

function mapStateToProps(state: StoreState, ownProps: OwnProps): StateProps {
    const selector = formValueSelector('order-form');
    const params = selector(state, 'orderTypeDropDown');
    const valueType: SelectObject = selector(state, 'orderCaseTypeDropDown');
    const statusItem = selector(state, 'statusDropDown');
    const typeEnum = OrderEnum ? OrderEnum.getEnum('OrderType') : {};
    const orderTypes: SelectObject[] = getValFromEnum(typeEnum);

    const orderTypeValue: string | number = params ? params.value : orderTypes ? orderTypes[0].value : 1;

    const statusEnum = OrderEnum ? OrderEnum.getEnum('OrderStatus') : {};
    const statusItems: SelectObject[] = getValFromEnum(statusEnum);

    const statusItemValue: string | number = statusItem ? statusItem.value : statusItems ? statusItems[0].value : 1;
    return {
        orderTypeValue,
        orderTypes,
        valueType,

        inProgress: state.orders.inProgress,
        serviceTypesOrder: state.serviceTypes.data,
        statusItemValue,
        students: selectNameStudents(state),
    };
}

function mapDispatchToProps(dispatch: Dispatch, ownProps: OwnProps): DispatchProps {
    return {
        getStudentsAct: (params: QueryParams) => dispatch(getStudents(params)),
        getOrderServiceTypes: (params: QueryParams) => dispatch(getServiceTypes(params)),
    };
}

const OrderCreateScreen = connect<StateProps, DispatchProps, OwnProps, StoreState>(
    mapStateToProps,
    mapDispatchToProps,
)(OrderCreate);

export default OrderCreateScreen;
